import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 20000 });

export const api = {
  discover: () => http.get("/discover").then(r => r.data),
  search: (params) => http.get("/search", { params }).then(r => r.data),
  series: () => http.get("/series").then(r => r.data),
  seriesDetail: (name) => http.get(`/series/${encodeURIComponent(name)}`).then(r => r.data),
  collections: () => http.get("/collections").then(r => r.data),
  item: (id) => http.get(`/item/${encodeURIComponent(id)}`).then(r => r.data),
  manifest: () => http.get("/manifest/series").then(r => r.data),
  manifestOne: (slug) => http.get(`/manifest/series/${encodeURIComponent(slug)}`).then(r => r.data),
  discipline: (slug) => http.get(`/discipline/${encodeURIComponent(slug)}`).then(r => r.data),
  next: (id) => http.get(`/next/${encodeURIComponent(id)}`).then(r => r.data),
};
